var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    },
    [
      _c("div", { staticClass: "fixed inset-0 transition-opacity" }, [
        _c("div", {
          staticClass: "absolute inset-0 bg-gray-500 opacity-75",
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        {
          staticClass:
            "relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-headline"
          }
        },
        [
          _c("div", { staticClass: "sm:flex sm:items-start" }, [
            _c(
              "div",
              { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
              [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg leading-6 font-medium text-gray-900",
                    attrs: { id: "modal-headline" }
                  },
                  [
                    !_vm.agent
                      ? _c("span", [_vm._v(" Add a new number ")])
                      : _vm._e(),
                    _vm.agent
                      ? _c("span", [_vm._v(" Edit a number ")])
                      : _vm._e()
                  ]
                ),
                _c("div", { staticClass: "mt-2" })
              ]
            )
          ]),
          _c("div", { staticClass: "sm:ml-4 mt-4" }, [
            _c("div", [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Name ")]
              ),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.form.name.$model,
                      expression: "$v.form.name.$model"
                    }
                  ],
                  ref: "name",
                  staticClass:
                    "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal",
                  attrs: { type: "text", placeholder: "Your agent name" },
                  domProps: { value: _vm.$v.form.name.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.$v.form.name, "$model", $event.target.value)
                    }
                  }
                }),
                !_vm.$v.form.name.maxLength
                  ? _c("p", { staticClass: "mt-2 text-sm text-red-600" }, [
                      _vm._v(
                        " Name should be less than " +
                          _vm._s(_vm.$v.form.name.$params.maxLength.max) +
                          " characters "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Role ")]
              ),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.form.description.$model,
                      expression: "$v.form.description.$model"
                    }
                  ],
                  ref: "role",
                  staticClass:
                    "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal",
                  attrs: { type: "text", placeholder: "Customer support" },
                  domProps: { value: _vm.$v.form.description.$model },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.form.description,
                        "$model",
                        $event.target.value
                      )
                    }
                  }
                }),
                !_vm.$v.form.description.maxLength
                  ? _c("p", { staticClass: "mt-2 text-sm text-red-600" }, [
                      _vm._v(
                        " Role should be less than " +
                          _vm._s(
                            _vm.$v.form.description.$params.maxLength.max
                          ) +
                          " characters "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Phone Number ")]
              ),
              _c(
                "div",
                { staticClass: "mt-1  rounded-md shadow-sm" },
                [
                  _c("vue-tel-input", {
                    attrs: {
                      value: _vm.form.phoneNumber,
                      mode: "international"
                    },
                    on: { input: _vm.handlePhoneNumberUpdate }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "my-4" }, [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Avatar ")]
              ),
              _c("div", { staticClass: "my-4 relative rounded-md flex" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.avatarUrl,
                      expression: "form.avatarUrl"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "avatar-male",
                    value:
                      "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg"
                  },
                  domProps: {
                    checked: _vm._q(
                      _vm.form.avatarUrl,
                      "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg"
                    )
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.form,
                        "avatarUrl",
                        "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg"
                      )
                    }
                  }
                }),
                _vm._m(0),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.avatarUrl,
                      expression: "form.avatarUrl"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "avatar-female",
                    value:
                      "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-female-2.svg"
                  },
                  domProps: {
                    checked: _vm._q(
                      _vm.form.avatarUrl,
                      "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-female-2.svg"
                    )
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.form,
                        "avatarUrl",
                        "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-female-2.svg"
                      )
                    }
                  }
                }),
                _vm._m(1)
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                },
                [
                  !_vm.agent
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50",
                          attrs: {
                            disabled: _vm.$v.form.$invalid,
                            type: "button"
                          },
                          on: { click: _vm.onCreate }
                        },
                        [_vm._v(" Add ")]
                      )
                    : _vm._e(),
                  _vm.agent
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50",
                          attrs: {
                            disabled: _vm.$v.form.$invalid,
                            type: "button"
                          },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v(" Update ")]
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                      attrs: { type: "button" },
                      on: { click: _vm.close }
                    },
                    [_vm._v(" Cancel ")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "avatar-male" } }, [
      _c("img", {
        staticClass: "w-10 rounded-full bg-green-700",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "avatar-female" } }, [
      _c("img", {
        staticClass: "w-10 rounded-full bg-green-700",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-female-2.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }